// extracted by mini-css-extract-plugin
export var container = "_ia-0";
export var content = "_ia-3";
export var customerTitle = "_ia-4";
export var empty = "_ia-5";
export var gray = "_ia-6";
export var header = "_ia-7";
export var info = "_ia-8";
export var loading = "_ia-2";
export var loadingCard = "_ia-9";
export var oneLine = "_ia-a";
export var personName = "_ia-e";
export var pillContainer = "_ia-b";
export var selected = "_ia-1";
export var text = "_ia-c";
export var twoLines = "_ia-d";
export var unread = "_ia-f";
export var unreadIndicator = "_ia-g";